<template>
	<div class="container pb_0">
		<div class="main type_01">
			<p class="text_t type1">
				{{ $t('rtr_business-operation-pay.title1') }}
			</p>
			<p class="text_n">
				{{ $t('rtr_business-operation-pay.text1') }}
			</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.signup') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>
		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box mb_16">
					<div class="bg_text_area left">
						<p class="text_t fc_white">
							{{ $t('rtr_business-operation-pay.title2') }}
							{{ $t('rtr_business-operation-pay.title3') }}
						</p>
						<p class="text_n fc_white">
							{{ $t('rtr_business-operation-pay.text2') }}
						</p>
					</div>
				</div>
				<div class="bg_box mb_16">
					<div class="pt_100">
						<p class="text_t type2 tac">
							{{ $t('rtr_business-operation-pay.title4') }}
							{{ $t('rtr_business-operation-pay.title5') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Exchange.vue',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
